import { ElementType, ReactNode } from 'react';

export enum ESidebarAttach {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}

/**
 * Prop configuration object for web and mobile cases
 *
 * todo:
 *   in future move orientation changes handling logic from styles to responsive config
 *   `interface IResponsiveConfig<T> {
 *     web: T;
 *     mobile: {
 *       portrait: T;
 *       landscape: T;
 *     }
 *   }
 *   with default values that can be overwritten
 */
export interface IResponsiveConfig<T> {
  web: T;
  mobile?: T;
}

/**
 * Props can be simple value or configuration object for web and mobile cases.
 */
export type TConfigProp<T> = T | IResponsiveConfig<T>;

export interface ISidebarItemDescriptor {
  id?: string | number;
  label?: ReactNode;
  header?: ReactNode;
  headerBackground?: string;
  headerMenu?: ReactNode;
  hash?: string;
  icon?: ReactNode;
  isClosable?: boolean;
  Content?: ElementType;
}

export interface IResponsiveSidebarContext {
  isHeaderEnabled: boolean;
  setIsHeaderEnabled(value: boolean): void;
}
